/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_DescriptionInputs */

const en_settings_credits_description = /** @type {(inputs: Settings_Credits_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your credits balance and history`)
};

const zh_settings_credits_description = /** @type {(inputs: Settings_Credits_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的额度余额和变动记录`)
};

/**
* | output |
* | --- |
* | "Your credits balance and history" |
*
* @param {Settings_Credits_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_description = /** @type {((inputs?: Settings_Credits_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_description(inputs)
	return zh_settings_credits_description(inputs)
});
export { settings_credits_description as "settings.credits.description" }